/**
 * Display helpers for a task's customer and drop-off facility.
 *
 * The CUSTOMER of a task is what was entered in the "Customer" box of Create Task
 * (stored as clientName and mirrored to companyName). It must never be replaced by
 * the drop-off facility. The backend stores clientName -> companyName -> hospitalName
 * (main.py _normalize_task_identity_fields), so this uses the same order and only
 * falls back to a facility name when the record has no customer at all.
 * The drop-off facility is displayed separately.
 */

const text = (v) => (typeof v === "string" || typeof v === "number" ? String(v).trim() : "");

export const getTaskCustomer = (t) => text(t?.clientName) || text(t?.companyName) || text(t?.hospitalName);

export const getTaskDropoffFacility = (t) => text(t?.dropoffFacilityName) || text(t?.hospitalName);

/** "Facility - address" for the Dropoff column / card (either part may be missing). */
export const getDropoffLabel = (t, sep = " \u00B7 ") =>
  [getTaskDropoffFacility(t), text(t?.dropoffAddress)].filter(Boolean).join(sep);
